/* =============================================================================
   bc-analytics-buttons.js — purchase-intent click tracking

   Fires a Shopify Web Pixels custom event (and a gtag fallback) whenever the
   visitor clicks one of the three purchase buttons on the product page:

     • Add to Cart        → event "bc_add_to_cart_click"   (destination: shopify_cart)
     • Buy on Amazon      → event "bc_marketplace_click"   (destination: amazon)
     • Купити на Stameski → event "bc_marketplace_click"   (destination: stameski)

   The events are published to the Shopify analytics bus so a Custom Pixel
   (Settings → Customer events) can subscribe and forward them to GA4 / Clarity.

   NOTE: This tracks the CLICK only. The actual Amazon/Stameski purchase happens
   off-platform and cannot be measured here — only their own attribution can.
   ============================================================================= */
(function () {
  'use strict';

  function getHandle() {
    var p = location.pathname;
    if (p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p.split('/').pop() || '';
  }

  /* Unified publisher — Shopify Web Pixels bus + gtag fallback. */
  function track(eventName, data) {
    var payload = {
      product_handle: getHandle(),
      page_path: location.pathname
    };
    for (var k in data) {
      if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
    }

    try {
      if (window.analytics && typeof window.analytics.publish === 'function') {
        window.analytics.publish(eventName, payload);
      } else if (window.Shopify && window.Shopify.analytics &&
                 typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (e) { /* never break the button on a tracking error */ }

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  }

  /* One delegated capture-phase listener catches every button, including the
     sticky bar and any buttons injected later by amz-product.js. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Marketplace (Amazon / Stameski) — main + sticky placeholders.
    var mkt = t.closest('[data-amz-btn], [data-amz-sticky-btn]');
    if (mkt) {
      var isUA = mkt.classList.contains('buy-on-amazon-btn--stameski');
      track('bc_marketplace_click', { destination: isUA ? 'stameski' : 'amazon' });
      return;
    }

    // Add to Cart — main submit + sticky submit.
    var atc = t.closest('.product-form__submit, [data-bc-sticky-submit]');
    if (atc && !atc.disabled) {
      track('bc_add_to_cart_click', { destination: 'shopify_cart' });
    }
  }, true);
})();
